// sidebar.component.ts - Alterações necessárias

import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router, Event, NavigationEnd } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { AcessoAPIService } from "src/app/modules/usuario/services/acesso-api.service";
import { PermissaoMenu } from "src/app/shared/interfaces/acesso/permissao-menu.interface";
import { ChamadosNaoVisualizados } from "src/app/shared/interfaces/chamado/chamado.interface";
import { Menu } from "src/app/shared/interfaces/menu.interface";
import { UsuarioLogado } from "src/app/shared/interfaces/usuario/usuario-logado.interface";
import { UsuarioService } from "src/app/shared/services/usuario.service";
import { PendenciasSgi } from "src/app/shared/interfaces/sgi-informacao-documentada/pendencias-sgi.interface";
import { SgiInformacaoDocumentadaAPIService } from "src/app/modules/sgi-informacao-documentada/services/sgi-informacao-documentada-api.service";
import { ChamadoAPIService } from "src/app/modules/chamado/services/chamado-api.service";
import { SacpmAPIService } from "src/app/modules/sacpm/services/sacpm-api.service";
import { PendenciasSacpm } from "src/app/shared/interfaces/sacpm/pendencias-sacpm.interface";
import { GestaoMudancaAPIService } from "src/app/modules/gestao-mudanca/services/gestao-mudanca-api.service";
import { PwaManagerService } from "src/app/shared/services/pwa-manager.service";

declare let $: any;

// Interface estendida para controle de estado
interface MenuComEstado extends Menu {
    expanded?: boolean;
    active?: boolean;
    subMenus: MenuComEstado[];
}

@Component({
    selector: "app-sidebar",
    templateUrl: "./sidebar.component.html",
    styleUrls: ["./sidebar.component.scss"]
})
export class SidebarComponent implements OnInit {
    // MANTER suas propriedades existentes, apenas alterar o tipo
    public menus: MenuComEstado[] = []; // ALTERADO: era MenuPrincipalComEstado[]
    public menusFiltrados: MenuComEstado[] = []; // ALTERADO: era MenuPrincipalComEstado[]
    public txtProcurarMenu: string = '';
    public isLoading: boolean = true;
    public currentUrl: string = '';
    public totalMeusChamados: number = 0;
    public totalMinhasAprovacoes: number = 0;
    public totalPendenciasSgiEnvio: number = 0;
    public totalPendenciasSgiAprovacao: number = 0;
    public totalSacpmMinhas: number = 0;
    public totalSacpmValidacao: number = 0;
    public totalGestaoMudanca: number = 0;
    private sgiTotaisCarregados: boolean = false;
    private sacpmTotaisCarregados: boolean = false;
    private gmTotaisCarregados: boolean = false;

    // Badge da Gestão de Mudanças = minhas ações + validações pendentes.
    get totalPendenciasGestaoMudanca(): number {
        return this.totalGestaoMudanca || 0;
    }

    // Badge único do SGI = soma das pendências de envio + aprovação
    get totalPendenciasSgi(): number {
        return (this.totalPendenciasSgiEnvio || 0) + (this.totalPendenciasSgiAprovacao || 0);
    }

    // Badge do SACPM = minhas ações + conclusões esperando minha validação.
    // Mesma lógica do SGI: um número só no menu, porque o destino é a mesma tela.
    get totalPendenciasSacpm(): number {
        return (this.totalSacpmMinhas || 0) + (this.totalSacpmValidacao || 0);
    }

    // O menu SGI é o pai do SACPM, então o badge dele soma os dois módulos —
    // senão o número do topo não bateria com o dos filhos.
    get totalPendenciasSgiComSacpm(): number {
        return this.totalPendenciasSgi + this.totalPendenciasSacpm + this.totalPendenciasGestaoMudanca;
    }
    @Input() isCollapsed: boolean = false;
    @Output() toggleSidebar = new EventEmitter<void>();
    
    constructor(
        private router: Router,
        private acessoService: AcessoAPIService,
        private usuarioService: UsuarioService,
        private sgiApiService: SgiInformacaoDocumentadaAPIService,
        private chamadoApiService: ChamadoAPIService,
        private sacpmApiService: SacpmAPIService,
        private gestaoMudancaApiService: GestaoMudancaAPIService,
        private pwaManager: PwaManagerService
    ) {
        // MANTER seu código existente do router.events
        router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                this.currentUrl = event.url;
                this.updateActiveMenu();
                $(".responsive-burger-menu").removeClass("active");
                $(".sidemenu-area").removeClass("active-sidemenu-area");
            }
        });
    }

    onToggleSidebar(): void {
        this.toggleSidebar.emit();
    }

    ngOnInit() {
        // MANTER seu código existente do burger menu
        $(".burger-menu").on("click", function() {
            $(this).toggleClass("active");
            $(".main-content").toggleClass("hide-sidemenu-area");
            $(".sidemenu-area").toggleClass("toggle-sidemenu-area");
            $(".top-navbar").toggleClass("toggle-navbar-area");
        });
        
        $(".responsive-burger-menu").on("click", function() {
            $(".responsive-burger-menu").toggleClass("active");
            $(".sidemenu-area").toggleClass("active-sidemenu-area");
        });

        this.usuarioService.getUsuarioLogado().subscribe(async (usuario: UsuarioLogado) => {
            if (usuario?.menus) { // ALTERADO:
                this.carregaMenus(usuario.menus); // ALTERADO: passa os menus diretamente
            }
            if (usuario?.id) {
                this.carregarTotaisSgi(usuario.id);
                this.carregarTotaisSacpm(usuario.id);
                this.carregarTotaisGestaoMudanca(usuario.id);
                this.carregarTotaisChamados();
            }
            this.isLoading = false;
        }, (err) => this.isLoading = false);

        this.usuarioService.getTotalChamados().subscribe(async (totalChamados: ChamadosNaoVisualizados) => {
            this.totalMeusChamados = totalChamados?.totalMeusAtendimentos ?? 0;
            this.totalMinhasAprovacoes = totalChamados?.totalMinhasAprovacoes ?? 0;
            this.isLoading = false;
        }, (err) => this.isLoading = false);

        // Contadores de pendências de SGI: atualizados em tempo real (SignalR via UsuarioService)
        this.usuarioService.getPendenciasSgi().subscribe((pendencias: PendenciasSgi) => {
            this.totalPendenciasSgiEnvio = pendencias?.totalEnvio ?? 0;
            this.totalPendenciasSgiAprovacao = pendencias?.totalAprovacao ?? 0;
        });

        // Contadores do SACPM. A tela Minhas Pendências republica esses números depois de
        // aprovar ou reprovar, para o badge não ficar preso no valor da carga inicial.
        this.usuarioService.getPendenciasSacpm().subscribe((pendencias: PendenciasSacpm) => {
            this.totalSacpmMinhas = pendencias?.totalMinhas ?? 0;
            this.totalSacpmValidacao = pendencias?.totalValidacao ?? 0;
        });
    }

    // Carga inicial dos contadores de chamado, direto do servidor.
    //
    // Antes o número vinha da resposta do login e era restaurado do
    // localStorage a cada navegação, sem nunca mais ser reconciliado com o
    // banco: aprovação feita por outra pessoa, em outra aba, ou com a aba
    // fechada, deixava o badge congelado — era o "7 no menu e tela vazia".
    private carregarTotaisChamados(): void {
        this.chamadoApiService.getMeusTotais().subscribe(
            (totais: ChamadosNaoVisualizados) => this.usuarioService.setTotalChamados(totais),
            () => { }
        );
    }

    // Carga inicial dos contadores de SGI (equivalente ao que os chamados trazem no login).
    // Envio = documentos pendentes do usuário; Aprovação = fila de revisão (vazia p/ quem não é do setor SGI).
    private carregarTotaisSgi(usuarioId: number): void {
        if (this.sgiTotaisCarregados) {
            return;
        }
        this.sgiTotaisCarregados = true;

        this.sgiApiService.getDocumentosPendentes(usuarioId).subscribe(
            (resp: any) => this.usuarioService.setTotalSgiEnvio(resp?.totalPendentes ?? resp?.documentos?.length ?? 0),
            () => { }
        );

        this.sgiApiService.getSolicitacoesRevisaoPendentes().subscribe(
            (lista) => this.usuarioService.setTotalSgiAprovacao(lista?.length ?? 0),
            () => { }
        );
    }

    // Carga inicial dos contadores do SACPM, no mesmo espírito do SGI.
    // A fila de validação não precisa de checagem de departamento aqui: a API resolve pelo
    // token e devolve lista vazia para quem não é do SGI, então o badge simplesmente não
    // aparece para quem não valida nada.
    private carregarTotaisSacpm(usuarioId: number): void {
        if (this.sacpmTotaisCarregados) {
            return;
        }
        this.sacpmTotaisCarregados = true;

        this.sacpmApiService.obterMinhasPendencias(usuarioId).subscribe(
            (lista) => this.usuarioService.setTotalSacpmMinhas(lista?.length ?? 0),
            () => { }
        );

        this.sacpmApiService.getPendenciasValidacao().subscribe(
            (lista) => this.usuarioService.setTotalSacpmValidacao(lista?.length ?? 0),
            () => { }
        );
    }

    // Contador da Gestão de Mudanças (simples, sem SignalR): minhas ações + validações.
    // A API resolve o usuário pelo token e devolve 0 para quem não tem pendência.
    private carregarTotaisGestaoMudanca(usuarioId: number): void {
        if (this.gmTotaisCarregados) {
            return;
        }
        this.gmTotaisCarregados = true;

        this.gestaoMudancaApiService.getContadorPendencias().subscribe(
            (c) => this.totalGestaoMudanca = (c?.minhas ?? 0) + (c?.validacao ?? 0) + (c?.aprovacaoInicial ?? 0),
            () => { }
        );
    }

    // ALTERAR esta função
    carregaMenus(menus: Menu[]): void {
        // Converter menus para MenuComEstado e inicializar propriedades de controle
        this.menus = this.convertToMenuComEstado(menus);
        this.menusFiltrados = [...this.menus];
        this.updateActiveMenu();
        this.isLoading = false;
    }

    // ADICIONAR estas novas funções
    private convertToMenuComEstado(menus: Menu[]): MenuComEstado[] {
        return menus.map(menu => ({
            ...menu,
            expanded: false,
            active: false,
            subMenus: menu.subMenus ? this.convertToMenuComEstado(menu.subMenus) : []
        }));
    }

    // SUBSTITUIR toggleMenuPrincipal e toggleSubMenu por uma única função
    toggleMenu(menu: MenuComEstado): void {
        const isCurrentlyExpanded = menu.expanded;
        
        if (isCurrentlyExpanded) {
            // Se está expandido, apenas fechar este menu e seus filhos
            menu.expanded = false;
            this.closeAllChildrenRecursively(menu);
        } else {
            // Se está fechado, fechar menus irmãos e abrir este
            this.closeSiblingMenus(menu);
            menu.expanded = true;
        }
    }

    // NOVA função para fechar apenas menus irmãos (mesmo nível)
    private closeSiblingMenus(targetMenu: MenuComEstado): void {
        // Encontrar o array pai que contém este menu
        const parentArray = this.findParentArray(targetMenu, this.menusFiltrados);
        
        if (parentArray) {
            // Fechar apenas os menus irmãos, mantendo os pais abertos
            parentArray.forEach(menu => {
                if (menu.id !== targetMenu.id) {
                    menu.expanded = false;
                    // Fechar recursivamente os filhos dos irmãos
                    this.closeAllChildrenRecursively(menu);
                }
            });
        }
    }

    // Função para encontrar o array pai que contém o menu
    private findParentArray(targetMenu: MenuComEstado, searchArray: MenuComEstado[]): MenuComEstado[] | null {
        // Verificar se o menu está neste array
        if (searchArray.some(menu => menu.id === targetMenu.id)) {
            return searchArray;
        }
        
        // Procurar recursivamente nos submenus
        for (const menu of searchArray) {
            if (menu.subMenus?.length > 0) {
                const found = this.findParentArray(targetMenu, menu.subMenus);
                if (found) {
                    return found;
                }
            }
        }
        
        return null;
    }

    // Função para fechar todos os filhos recursivamente
    private closeAllChildrenRecursively(menu: MenuComEstado): void {
        if (menu.subMenus?.length > 0) {
            menu.subMenus.forEach(child => {
                child.expanded = false;
                this.closeAllChildrenRecursively(child);
            });
        }
    }

    // SUBSTITUIR a função closeAllMenusAtLevel original por uma versão que preserva hierarquia
    private closeAllMenusAtLevel(menus: MenuComEstado[]): void {
        menus.forEach(menu => {
            menu.expanded = false;
            if (menu.subMenus?.length > 0) {
                this.closeAllMenusAtLevel(menu.subMenus);
            }
        });
    }

    // MANTER sua função navigateTo existente
    navigateTo(path: string): void {
        if (path && path !== '#' && path !== 'javascript:void(0)') {
            // false = um guard cancelou (ex.: alterações não salvas, hoje só no Chamado): não recarrega.
            // null = clique no menu da tela atual, que o Router ignora: recarrega também.
            this.router.navigate([path]).then(navegou => {
                if (navegou !== false) this.pwaManager.recarregarSeHouverVersaoNova();
            });
        }
    }

    // SUBSTITUIR updateActiveMenu por esta versão
    updateActiveMenu(): void {
        this.updateActiveMenuRecursively(this.menusFiltrados);
        this.expandOnlyActivePath();
    }

    private updateActiveMenuRecursively(menus: MenuComEstado[]): void {
        menus.forEach(menu => {
            menu.active = this.isMenuActive(menu.caminho);
            if (menu.subMenus?.length > 0) {
                this.updateActiveMenuRecursively(menu.subMenus);
            }
        });
    }

    private expandOnlyActivePath(): void {
        // Se nenhum menu corresponde à URL atual (ex: páginas de detalhe com ID),
        // mantém o estado expandido atual em vez de recolher tudo
        const hasActivePath = this.checkHasActivePath(this.menusFiltrados);
        if (!hasActivePath) {
            return;
        }
        this.closeAllMenusAtLevel(this.menusFiltrados);
        this.expandActivePathRecursively(this.menusFiltrados);
    }

    private checkHasActivePath(menus: MenuComEstado[]): boolean {
        for (const menu of menus) {
            if (menu.active) return true;
            if (menu.subMenus?.length > 0 && this.checkHasActivePath(menu.subMenus)) return true;
        }
        return false;
    }

    private expandActivePathRecursively(menus: MenuComEstado[]): boolean {
        let hasActiveChild = false;
        
        menus.forEach(menu => {
            let shouldExpand = false;
            
            if (menu.active) {
                shouldExpand = true;
                hasActiveChild = true;
            }
            
            if (menu.subMenus?.length > 0) {
                const hasActiveSubMenu = this.expandActivePathRecursively(menu.subMenus);
                if (hasActiveSubMenu) {
                    shouldExpand = true;
                    hasActiveChild = true;
                }
            }
            
            menu.expanded = shouldExpand;
        });
        
        return hasActiveChild;
    }

    // MANTER sua função isMenuActive existente (apenas alterar assinatura)
    private isMenuActive(caminho?: string): boolean {
        if (!caminho || caminho === '#' || caminho === 'javascript:void(0)') {
            return false;
        }
        
        const cleanPath = caminho.startsWith('/') ? caminho.substring(1) : caminho;
        const cleanCurrentUrl = this.currentUrl.startsWith('/') ? this.currentUrl.substring(1) : this.currentUrl;
        
        return cleanCurrentUrl === cleanPath;
    }

    // SUBSTITUIR filtrarMenu por esta versão
    filtrarMenu(): void {
        const term = this.txtProcurarMenu.toLowerCase().trim();
        
        if (!term) {
            this.menusFiltrados = [...this.menus];
            this.updateActiveMenu();
            return;
        }
        
        this.menusFiltrados = this.filterMenusRecursively(this.menus, term);
        this.expandFilteredMenus(this.menusFiltrados);
    }

    private filterMenusRecursively(menus: MenuComEstado[], term: string): MenuComEstado[] {
        return menus.map(menu => {
            const filteredSubMenus = menu.subMenus?.length > 0 
                ? this.filterMenusRecursively(menu.subMenus, term)
                : [];

            const menuMatches = menu.nome.toLowerCase().includes(term);
            const hasMatchingSubMenus = filteredSubMenus.length > 0;

            if (menuMatches || hasMatchingSubMenus) {
                return {
                    ...menu,
                    subMenus: filteredSubMenus,
                    expanded: hasMatchingSubMenus
                };
            }
            return null;
        }).filter(menu => menu !== null) as MenuComEstado[];
    }

    private expandFilteredMenus(menus: MenuComEstado[]): void {
        menus.forEach(menu => {
            if (menu.subMenus?.length > 0) {
                menu.expanded = true;
                this.expandFilteredMenus(menu.subMenus);
            }
        });
    }

    // ADICIONAR funções auxiliares para o template
    hasSubMenus(menu: MenuComEstado): boolean {
        return menu.subMenus && menu.subMenus.length > 0;
    }

    getMenuIcon(menu: MenuComEstado): string {
        return menu.icone || 'bx bx-circle';
    }

    // ADICIONAR função para obter menus principais (nível 1)
    getMenusPrincipais(): MenuComEstado[] {
        return this.menusFiltrados.filter(menu => menu.nivel === 1);
    }

    // REMOVER as funções antigas se existirem:
    // - toggleMenuPrincipal
    // - toggleSubMenu
    // - expandOnlyActivePath (versão antiga)
    // - filtrarMenusPorPermissao (se não usar mais permissões)
}